// src/utils/supabase.js
import { createClient } from "@supabase/supabase-js";

const URL = process.env.REACT_APP_SUPABASE_URL;
const KEY = process.env.REACT_APP_SUPABASE_KEY;

export const SUPABASE_READY = !!URL && !!KEY;

export const supabase = SUPABASE_READY ? createClient(URL, KEY) : null;